import type { ReactNode } from "react";

/** What a list shows when it has nothing: why, and the one thing to do about it. */
export function EmptyState({
  icon,
  title,
  children,
  action,
}: {
  icon: ReactNode;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center rounded-card border border-dashed border-line-strong bg-surface px-6 py-14 text-center">
      <span
        aria-hidden="true"
        className="mb-4 grid size-11 place-items-center rounded-full bg-accent-soft text-accent [&_svg]:size-5"
      >
        {icon}
      </span>
      <p className="text-[15px] font-medium text-ink">{title}</p>
      {children ? <p className="mt-1 max-w-sm text-sm text-muted">{children}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
